import { useCallback, useMemo } from "react";
import { IMaskInput } from "react-imask";

import { styles } from "@repo/helpers";

import { InputComponent } from "../input";
import style from "./style.module.scss";
import { MarkupProps } from "./types";

export default function Markup(args: MarkupProps) {
	const { maskOptions, type, inputMode, autocompleteList, ...inputArgs } = args;
	const { id, error, name, className, disabled, onChangeValue } = inputArgs;
	const inputProps = useMemo(() => {
		return {
			onKeyDown: args.onKeyDown,
			className: styles(
				className,
				style.formControl,
				style.inputGroupField,
				error && style.error,
				disabled && style.disabled,
			),
			name: name || id,
			type,
			inputMode,
			id: inputArgs.id,
			disabled: disabled,
			//TODO: need to test if this breaks numeric inputs
			minLength: inputArgs.min,
			maxLength: inputArgs.max,
			value: inputArgs.value ?? "",
			readOnly: inputArgs.readOnly,
			onChange: maskOptions ? undefined : args.onChange,
			onBlur: args.onUnfocused,
			onFocus: args.onFocused,
			onWheel: (e) => type == "number" && e.target.blur(),
			placeholder: args.placeholder,
			autoComplete: args.autocomplete,
			list: args.autocompleteList ? inputArgs.id + "DataList" : undefined,
		};
	}, [args, inputArgs]);

	const maskOpts = useMemo(() => {
		return {
			...maskOptions,
			unmask: false,
			overwrite: false,
		};
	}, [maskOptions]);

	const DataList = useCallback(() => {
		if (!args.autocompleteList?.length) return null;
		return (
			<datalist id={inputProps.list}>
				{autocompleteList
					.filter((l) => l != args.value)
					.map((l) => (
						<option key={l} value={l} />
					))}
			</datalist>
		);
	}, [args.autocompleteList, inputProps.list]);

	return (
		<InputComponent {...inputArgs}>
			{maskOptions ? (
				<IMaskInput inputRef={args.setRef} {...inputProps} {...maskOpts} onAccept={onChangeValue} />
			) : (
				<input {...inputProps} />
			)}
			<DataList />
		</InputComponent>
	);
}
